export const addKeyInEach = <TKey extends string, TValue, TEach>(
    key: TKey,
    valueFunc: (item: TEach) => TValue,
    data: TEach[],
) => (
    data.map(item => {
        return {
            ...item,
            [key]: valueFunc(item),
        };
    })
);